import api from '@/utils/api';

/**
 * Get company option by price link id
 * @param {string} companyId - Query to filter companies
 * @param {string} priceLinkId - The price link id
 * @returns {Promise}
 */
const getCompanyOptionByPriceLinkIdApi = (companyId, priceLinkId) =>
  api.get(`company/${companyId}/option/price-link/${priceLinkId}`);

export default getCompanyOptionByPriceLinkIdApi;
